import { Card, Empty, Space, Spin, Tabs, Typography } from 'antd';
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { StoreState } from 'src/store/configureStore'
import { AsyncStates } from 'src/constants'
import { PerformancePercentageResult } from './PerformancePercentageResult'
import useTranslate from 'src/utils/useTranslate'

type Props = {
  currentSelectedStage: number
}

const { Title } = Typography

export const PerformancePercentage = memo(({ currentSelectedStage }: Props) => {
  const [t] = useTranslate()

  const { performanceData, getPerformanceStatus } = useSelector((state: StoreState) => state.performance)

  const displayNames = useSelector((state: StoreState) => state.displayNames.data)
  return (
    <Card
      title={
        <Space direction="vertical">
          <Title level={4}>{t('aiEngine.modelAnalysis.dataAndModelPerformanceValidation')}</Title>
        </Space>
      }
    >
      <Spin spinning={getPerformanceStatus === AsyncStates.LOADING}>
        {getPerformanceStatus === AsyncStates.SUCCESS && Object.keys(performanceData || {}).length > 0 ? (
          <Tabs
            items={Object.keys(performanceData.data_performance_percentage || {}).map((property, index) => ({
              key: `${index}`,
              label: (
                <Title style={{ margin: '0', userSelect: 'none' }} level={4}>
                  {performanceData?.display_names?.[property] ?? displayNames.properties?.[property]?.name ?? property}
                </Title>
              ),
              children: <PerformancePercentageResult index={index} property={property} currentSelectedStage={currentSelectedStage} />
            }))}
            tabBarStyle={{ paddingBottom: '1rem' }}
            destroyInactiveTabPane
          />
        ) : (
          <Empty
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
        )}
      </Spin>
    </Card>
  )
})
